//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports 
import { CategoryModel, RoomContentModel } from '@app/catalog';

@Component({
  selector: 'assign-room-content-to-category',
  standalone: false,
  templateUrl: './assign-room-content-to-category.component.html',
  styleUrl: './assign-room-content-to-category.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignRoomContentToCategoryComponent {
  onCancelAssignment = output();

  roomContents = input.required<RoomContentModel[]>();
  assignedRoomContents = input.required<RoomContentModel[]>();
  categories = input.required<CategoryModel[]>();



  public applyAssignment() {

  }
}
